import { render, staticRenderFns } from "./CoordinateForm.vue?vue&type=template&id=e548775c&scoped=true&"
import script from "./CoordinateForm.vue?vue&type=script&lang=js&"
export * from "./CoordinateForm.vue?vue&type=script&lang=js&"
import style0 from "./CoordinateForm.vue?vue&type=style&index=0&id=e548775c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e548775c",
  null
  
)

export default component.exports